import config from '../../config';
import makeScriptPromise from '../../lib/makeScriptPromise';
import { useEffectOnFirstRender } from '../../hooks';

const SMART_LOOK_API_KEY = 'b278cf3b2ee197c26b0f17ad6835daa78bf23565';

const initTawk = async () =>
  await makeScriptPromise(`https://embed.tawk.to/${config.tawkId}/default`);

async function initSmartLook(key) {
  const w = window;
  if (w.smartlook) return;

  w.smartlook = function() {
    w.smartlook.api.push(arguments);
  };

  w.smartlook.api = [];
  w.smartlook('init', key);

  await makeScriptPromise('https://rec.smartlook.com/recorder.js');
}

export default function CustomerSupport() {
  useEffectOnFirstRender(() => {
    initTawk();
    initSmartLook(SMART_LOOK_API_KEY);
  }, []);

  return null;
}



// WEBPACK FOOTER //
// ./src/components/CustomerSupport/CustomerSupport.js